import ACTIONS from '../actions.js';
import { USER_TYPES} from '../../config';


export default function appReducer(state, action) {
  switch(action.type) {
    case ACTIONS.UPDATE_PASSWORD_SUCCESSFUL: 
      return {
        ...state,
        user: action.payload
      }
    case ACTIONS.UPDATE_EMAIL_SUCCESSFUL: 
      return {
        ...state,
        user: {
          ...state.user,
          email: action.payload,
          verified: false
        }
      }
    case ACTIONS.LOGIN_START: 
      return {
        ...state,
        isAuthenticated: false,
        userAccount: {
          isAdmin: false,
          isPatient: false,
          isPartner: false,
          isStaff: false,
          isRoot: false,
          isPatientOrPartner: false,
          isPatientOrAdmin: false,
          isPartnerOrAdmin: false,
        },
        isLoading: true
      }
    case ACTIONS.LOGIN_COMPLETE: 
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        isLoading: false
      }
    case ACTIONS.LOGIN_FAILED: 
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false
      }
    case ACTIONS.LOGOUT: 
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false
      }
    case ACTIONS.REGISTER_START: 
      return {
        ...state,
        isAuthenticated: false,
        isLoading: true
      }
    case ACTIONS.REGISTER_COMPLETE: 
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        isLoading: false
      }
    case ACTIONS.REGISTER_FAILED: 
      return {
        ...state,
        isAuthenticated: false,
        isLoading: false
      }
    case ACTIONS.AUTHENTICATE_COMPLETE: 
      let user = action.payload;
      switch (user.user_type) {
        case USER_TYPES.PARTNER:
          return {
            ...state,
            user: action.payload,
            userAccount: {
              ...state.userAccount, isPartner: true, isPatientOrPartner: true, isPartnerOrAdmin: true
            },
            isAuthenticated: true,
          }
        case USER_TYPES.PATIENT:
          return {
              ...state,
              user: action.payload,
              userAccount: {
                ...state.userAccount, isPatient: true, isPatientOrPartner: true, isPatientOrAdmin: true 
              },
              isAuthenticated: true,
            }  
        case USER_TYPES.ROOT:
          return {
            ...state,
            user: action.payload,
            userAccount: {
              ...state.userAccount, isRoot: true, isAdmin: true, isPatientOrAdmin: true, isPartnerOrAdmin: true
            },
            isAuthenticated: true,
          } 
        case USER_TYPES.STAFF:
          return {
            ...state,
            user: action.payload,
            userAccount: {
              ...state.userAccount, isAdmin: true, isStaff: true, isPatientOrAdmin: true, isPartnerOrAdmin: true
            },
            isAuthenticated: true,
          } 
        default:
          break;
      }    
      break;
    case ACTIONS.AUTHENTICATE_FAILED: 
      return {
        ...state,
        user: {},
        isAuthenticated: false,
      }
    case ACTIONS.UPDATE_USER_COMPLETE: 
      return {
        ...state,
        user: action.payload,
      }
    case ACTIONS.UPDATE_PROFILEPIC_COMPLETE: 
    const updatedUser = {
      ...state.user,
      profile_pic_url: action.payload
    }
    return {
        ...state,
        user: updatedUser
      }
    case ACTIONS.GET_USER_TYPES_COMPLETE: 
      return {
        ...state,
        userTypes: action.payload,
      }
    case ACTIONS.GET_PARTNER_TYPES_COMPLETE: 
      return {
        ...state,
        partnerTypes: action.payload,
      }
    case ACTIONS.GET_ALL_USER_NOTIFICATIONS: 
      return {
        ...state,
        userNotifications: action.payload,
      }
    default: 
      throw new Error(`Unhandled action type: ${action.type}`)
  };
}